import Vue from 'vue'
import App from './App.vue'
// import router from './router'
import store from './store'
// import Konva from 'konva';
import VueKonva from 'vue-konva';
// import router from './router'

// Importowanie stylów Bootstrapa
// import 'bootstrap/dist/css/bootstrap.min.css';

// Importowanie skryptu JS Bootstrapa
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// import './assets/styles.scss';


Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.use(VueKonva);
// Vue.use(router);

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
